export default "__VITE_ASSET__Byd1mOiV__"